import numeral from 'numeral';

export default (value: number | string) => {
    if (value != null) {
        const parsedValue = parseFloat(value);
        return parsedValue < 0.01
            ? parsedValue.toPrecision(1)
            : numeral(parsedValue).format('0,0.00');
    } else {
        return null;
    }
};
